export const APP_PRIZE_COINS = {
    EMOJI: 500,
    INVITE: 100,
    QR: 5000,
    STORY: 40,
    SUBSCRIBE: 200,
    TRAILER: 1000,
}
